import {
  AddCircleRounded,
  CheckBox,
  CheckBoxOutlineBlank,
  RemoveCircleRounded,
} from '@mui/icons-material';
import { IconButton, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCameraOverlayMutations } from '../hooks';
import { CameraIrisFocusControlsProps } from '../types';
import useCameraDetailsOverlayStyles from 'components/CameraDetailsOverlay/styles';
import { FOCUS_SPEED } from 'components/CameraDetailsOverlay/constants';

const CameraFocus: React.FunctionComponent<CameraIrisFocusControlsProps> = (props) => {
  const classes = useCameraDetailsOverlayStyles();
  const { t } = useTranslation(['video', 'common']);

  const { data, refetchData } = props;

  const { enableAutoFocus, focusCamera } = useCameraOverlayMutations(data?.id, refetchData);

  return (
    <div className={classes.cameraControls}>
      <Typography fontSize='small' variant='body1' className={classes.controlText}>
        {t('common:focus')}
      </Typography>
      <div className={classes.controlsButtonsWrapper}>
        <IconButton size='small' onClick={() => focusCamera?.(data.id, -FOCUS_SPEED)}>
          <RemoveCircleRounded className={classes.videoControllsButton} fontSize='small' />
        </IconButton>
        <IconButton size='small' onClick={() => focusCamera?.(data.id, FOCUS_SPEED)}>
          <AddCircleRounded className={classes.videoControllsButton} fontSize='small' />
        </IconButton>
        {data.autoFocusEnabled ? (
          <IconButton onClick={() => enableAutoFocus?.(data.id, false)} size='small'>
            <CheckBox className={classes.videoControllsButton} fontSize='small' />
          </IconButton>
        ) : (
          <IconButton onClick={() => enableAutoFocus?.(data.id, true)} size='small'>
            <CheckBoxOutlineBlank className={classes.videoControllsButton} fontSize='small' />
          </IconButton>
        )}
        <Typography variant='body1' fontSize='small'>
          {t('common:auto')}
        </Typography>
      </div>
    </div>
  );
};

export default CameraFocus;
